import React from "react";
import { styled } from "@mui/material/styles";
import Chip from "@mui/material/Chip";
import { ESituacionOperacion } from "api/types/originacion/businessTypes";

const buildLabel = (background: string, foreground: string) =>
  styled(Chip)({
    backgroundColor: background,
    color: foreground,
    borderRadius: 4,
    padding: 4,
    height: "auto",
    "& .MuiChip-label": { fontWeight: "bold" },
  });

const YellowLabel = buildLabel("#fff7cc", "#ee9d00");
const RedLabel = buildLabel("#ffe0e0", "#dd1111");
const BlueLabel = buildLabel("#c7f2fa", "#009bba");
const GreenLabel = buildLabel("#d2f6e2", "#069661");
const OrangeLabel = buildLabel("#ffeece", "#f17f00");

const EstadoSolicitudLabel: React.FC<{
  estadoSolicitud: ESituacionOperacion;
}> = ({ estadoSolicitud }) => {
  switch (estadoSolicitud) {
    case ESituacionOperacion.Rechazada:
    case ESituacionOperacion.Rechazada_Definitivamente:
      return <RedLabel label="Rechazada" />;
    case ESituacionOperacion.En_Analisis:
      return <YellowLabel label="En Análisis" />;
    case ESituacionOperacion.Desistida:
    case ESituacionOperacion.Desistida_por_tiempo:
      return <RedLabel label="Desistida" />;
    case ESituacionOperacion.Aprobada:
      return <GreenLabel label="Aprobada" />;
    case ESituacionOperacion.Informes_Pendientes:
      return <BlueLabel label="Informes Pendientes" />;
    case ESituacionOperacion.En_Espera_Informes_Riesgo_Vehiculo:
      return <OrangeLabel label="Inf. Riesgo Vehiculo Pendientes" />;
    case ESituacionOperacion.Confeccion_Solicitada:
      return <YellowLabel label="Confección Solicitada" />;
    case ESituacionOperacion.Prenda_Confeccionada:
      return <GreenLabel label="Prenda Confeccionada" />;
    case ESituacionOperacion.Liquidacion_solicitada:
      return <YellowLabel label="Liquidación Solicitada" />;
    case ESituacionOperacion.Carga_Incompleta:
    case ESituacionOperacion.No_Apto_Habilitado:
      return <BlueLabel label="Incompleta" />;
    case ESituacionOperacion.Liquidada:
      return <OrangeLabel label="Liquidada" />;
    default:
      return <YellowLabel label="En Análisis" />;
  }
};

export default EstadoSolicitudLabel;
